<div [ngClass]="[step()]">
	<app-header
		[journeyStep]="step()"
		[activity]="activity()"
		[enableNext]="enableNext()"
		(next)="onNext()"
		(up)="onUp()"
		(info)="header.showInstructions()"
		#header
	></app-header>

	<div class="fade-in">
		@switch (step()) {
			@case (JourneyStep.CHOOSE_COURSE_AND_UNIT_AND_LESSON) {
				@if (client(); as client) {
					<app-page-box>
						@if (!client.active_text?.logo_uri) {
							<h1>{{ client.active_text?.name }}</h1>
						}
						@if (client.active_text?.logo_uri) {
							<div class="client-logo">
								<img [src]="client.active_text?.logo_uri" [title]="client.active_text?.name" />
							</div>
						}

						@for (course of coursesMatchingSection(); track course.uuid) {
							<app-course [course]="course" (onLessonSelected)="onLessonSelected($event)"></app-course>
						}
					</app-page-box>
				}
			}

			@case (JourneyStep.CHOOSE_ACTIVITY) {
				<app-carousel></app-carousel>
			}

			@case (JourneyStep.PLAY_ACTIVITY) {
				@if (activity() && lesson()) {
					<app-player [activity]="activity()"></app-player>
				}
			}
		}
	</div>
</div>
